<template>
  <div class="col-md-3 col-lg-2 header-navbar-outer">
    <div class="w-100">
      <div class="navbar-brand-1 me-0">
        <div class="d-flex justify-content-between align-items-center">
          <!-- <div class="logo-outer">
            <img src="/assets/images/vc-logo.png" alt="" />
          </div> -->
          <div class="header-police-logo-outer">
            <div class="header-police-logo-inner w-100">
              <img src="/assets/images/central-logo.png" class="header-goa-logo" alt="Central Data" />
              <!-- <div class="header-goa-label text-uppercase">Shrikant Shinde</div> -->
            </div>
          </div>
        </div>
      </div>
      <nav id="sidebarMenu" class="d-md-block collapse nav-navlink-outer">
        <div class="menubar-outer">
          <div class="menubar-submeanu-outer" v-for="(menuItem, headIndex) in sidebarMenu" :key="headIndex">
            <ul class="nav flex-column" :id="'header-' + headIndex">
              <li class="nav-item">
                <!-- Replace ONLY this section inside <li class="nav-item"> -->
                <router-link v-if="menuItem.menu" :class="{ activeParent: isActive(menuItem.link) }"
                  class="nav-link d-flex align-items-center" :to="menuItem.link || ''" @click="openSubmenu = null">
                  <span>
                    <img :src="menuItem.img" class="navlink-tab-icon" alt="menu" width="16" />
                  </span>
                  <span>{{ menuItem.menu }}</span>
                </router-link>

                <!-- SUBMENU -->
                <template v-else-if="menuItem.menuHeader">
                  <button class="sidebar-parent-menu d-flex align-items-center justify-content-between w-100"
                    @click="toggleSubmenu(headIndex)">
                    <div class="d-flex align-items-center">
                      <img :src="menuItem.img" class="navlink-tab-icon" alt="menu" width="16" />
                      <span class="sidebar-parent-label">
                        {{ menuItem.menuHeader }}
                      </span>
                    </div>
                    <i class="pi sidebar-arrow"
                      :class="openSubmenu === headIndex ? 'pi-angle-up' : 'pi-angle-down'"></i>
                  </button>
                  <!-- Child Menu -->
                  <transition name="submenu">
                    <div v-show="openSubmenu === headIndex" class="sidebar-submenu-wrapper">
                      <ul class="sidebar-submenu-list">
                        <li v-for="(subMenu, index) in menuItem.sidebarSubMenu" :key="index">
                          <router-link class="sidebar-submenu-link" :class="{ activeParent: isActive(subMenu.link) }"
                            :to="subMenu.link">
                            <span>
                              <img :src="subMenu.img" class="navlink-tab-icon" alt="menu" width="16" />
                            </span>
                            {{ subMenu.submenu }}
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </transition>
                </template>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div class="copyright-outer mt-auto">
        <div class="copyright-inner">
          <div>
            <img src="/assets/images/edynamics-logo.png" height="50" alt="" width="150" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import ApiService from "../service/ApiService";
export default {
  data() {
    return {
      openSubmenu: null,
      sidebarMenu: [
        {
          menu: "Dashboard",
          link: "/dashboard",
          img: "/assets/images/new-icon/Vector.svg",
        },
        {
          menu: "Users",
          link: "/users",
          img: "/assets/images/new-icon/bell.svg",
        },
        {
          menu: "Clients",
          link: "/clients",
          img: "/assets/images/new-icon/client.svg",
        },
        {
          menu: "Products",
          link: "/products",
          img: "/assets/images/new-icon/arrow.svg",
        },
        {
          menu: "End Clients",
          link: "/endClients",
          img: "/assets/images/new-icon/list.svg",
        },
        {
          menu: "Vendors",
          link: "/vendor",
          img: "/assets/images/new-icon/meeting.svg",
        },
        {
          menu: "API Settings",
          link: "/govApiSettings",
          img: "/assets/images/new-icon/report.svg",
        },
        {
          menu: "Services",
          link: "/services",
          img: "/assets/images/new-icon/document-btn.svg",
        },
        {
          menu: "Companies & Sender Id",
          link: "/Companysenderid",
          img: "/assets/images/new-icon/Group2.svg",
        },
        {
          menu: "Cloud Telephony",
          link: "/D_I_D/Numbers/free-numbers",
          img: "/assets/images/new-icon/cloud.png",
        },
        {
          menuHeader: "Billing",
          img: "/assets/images/new-icon/billing.svg",
          sidebarSubMenu: [
            {
              submenu: "Client Billing",
              link: "/billing/clientbilling",
              img: "/assets/images/new-icon/clientbilling.svg",
            },
            {
              submenu: "Tax Invoice",
              img: "/assets/images/new-icon/taxinvoice.svg",
              link: "/billing/taxinvoice"
            },
            {
              submenu: "Payment Receipt",
              img: "/assets/images/new-icon/receipt.svg",
              link: "/billing/paymentreceipt"
            }
          ]
        },
        {
          menu: "API Consumption",
          link: "/apiconsumption",
          img: "/assets/images/new-icon/api-call-history.svg",
        },
        {
          menu: "API Status ",
          link: "/apistatus",
          img: "/assets/images/new-icon/api-status.svg",
        },
        // {
        //   menu: "SMS Sender Id",
        //   link: "/smssenderid",
        //   img: "/assets/images/new-icon/Group2.svg",
        // },

        // {
        //   menuHeader: "Billing",
        //   img: "/assets/images/new-icon/menu-billing.svg",
        //   sidebarSubMenu: [
        //     {
        //       submenu: "Dashboard",
        //       link: "/billing/dashboard"
        //     },
        //     {
        //       submenu: "Live Balance",
        //       link: "/billing/livebalance"
        //     },
        //     {
        //       submenu: "Tax Invoices",
        //       link: "/billing/invoice"
        //     },
        //     {
        //       submenu: "Account Statement",
        //       link: "/billing/statement"
        //     },
        //     {
        //       submenu: "Payment Receipts",
        //       link: "/billing/receipt"
        //     },
        //     {
        //       submenu: "Rate Card",
        //       link: "/billing/ratecard"
        //     },
        //   ]
        // },
        // {
        //   menu: "Search History",
        //   link: "/searchhistory",
        //   img: "/assets/images/new-icon/menu-guest.svg",
        // },
        // {
        //   menu: "Support",
        //   link: "/support/new",
        //   img: "/assets/images/new-icon/menu-campaign.svg",
        // },
        // {
        //   menuHeader: "System Settings",
        //   img: "/assets/images/new-icon/menu-billing.svg",
        //   sidebarSubMenu: [
        //     {
        //       submenu: "Batch",
        //       link: "/settings/batch"
        //     },
        //     {
        //       submenu: "Rank",
        //       link: "/settings/rank"
        //     },
        //     {
        //       submenu: "Signup Domains",
        //       link: "/settings/signupdomains"
        //     },
        //     {
        //       submenu: "Skip List",
        //       link: "/settings/skiplist"
        //     },
        //   ]
        // },
        // {
        //   menu: "Directory",
        //   link: "/directory",
        //   img: "/assets/images/new-icon/menu-campaign.svg",
        // },
        // {
        //   menu: "Scam Centers",
        //   link: "/scamcenters",
        //   img: "/assets/images/new-icon/menu-deepsearch.svg",
        // },
        // {
        //   menu: "About Deep Search",
        //   link: "/aboutdeepsearch",
        //   img: "/assets/images/new-icon/menu-campaign.svg",
        // },
      ],
    };
  },
  methods: {
    isActive(path) {
      return this.$route.path.startsWith(
        path.split('/').slice(0, 3).join('/')
      );
    },
    toggleSubmenu(index) {
      this.openSubmenu =
        this.openSubmenu === index ? null : index;
    }
  }

};
</script>
<style scoped>
.nav-link.activeParent {
  background: linear-gradient(331.87deg, rgba(63, 94, 251, 0.44) 43%, rgba(0, 0, 0, 0) 97.4%);
  color: #000;
  font-weight: 600;
}
</style>